module.exports = __webpack_public_path__ + "img/default-image.37c007b3.png";